import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardStatsCard = ({ stat }) => {
  return (
    <div className="card-elevated p-6">
      <div className="flex items-center justify-between mb-3">
        <div className={`w-12 h-12 rounded-lg bg-muted flex items-center justify-center ${stat?.color}`}>
          <Icon name={stat?.icon} size={24} />
        </div>
      </div>
      <div>
        <p className="text-sm text-muted-foreground mb-1">{stat?.label}</p>
        <p className="text-2xl font-bold text-foreground mb-1">{stat?.value}</p>
        <p className="text-xs text-muted-foreground">{stat?.change}</p>
      </div>
    </div>
  );
};

export default DashboardStatsCard;